export default __webpack_public_path__ + "static/media/mmgcommunications.545e5c09.png";